/** @file slotsJson: the `slots.json` export of the Art screen: every slot, its view and its image id. */
import { deriveSlots } from '@zilo/pose3d-format/derive/deriveSlots';
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import type { SlotViewAngles } from './artTypes';
import { imageOfSlot } from './imageOfSlot';

/**
 * `{ format, puppet, revision, slots }`: `deriveSlots(puppet)` in order, each with its view when known and `image`
 * (the filling image id, or null), as pretty-printed JSON text.
 */
export function slotsJson(doc: { id: string; revision: number; puppet: Puppet }, views: ReadonlyMap<string, SlotViewAngles>): string {
  const slots = deriveSlots(doc.puppet).map((s) => {
    const view = views.get(s.key);
    return { ...s, ...(view === undefined ? {} : { view }), image: imageOfSlot(doc.puppet, s.key) };
  });
  return JSON.stringify({ format: 'pose3d/slots@1', puppet: doc.id, revision: doc.revision, slots }, null, 2);
}
